import React from 'react';
import { Form, TextAreaBox } from 'fw/forms';
import { Col, Modal, FormGroup, Row, Button } from 'react-bootstrap';
import * as APIRoutes from 'modules/app/API';
import API from 'fw/system/API';
import * as Notifications from 'fw/globals/Notifications';

class CommentPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            visible: props.visible,

            saving: false,
            loadingData: false,

            buttons: {
                save: { disabled: false }
            },

            form: {
                comments: null
            },

            entityId: 0
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            visible: nextProps.visible,
            saving: false
        });
    }

    urls() {
        return {
            addComment: APIRoutes.Admin.url('/comment/addComment')
        }
    }

    saveRequest() {
        return {
            certificationKey: this.props.certificationKey,
            reviewTypeCode: this.props.reviewTypeCode,
            queueTypeCode: this.props.queueTypeCode,
            commentTypeCode: this.props.commentTypeCode,
            content: this.state.form.comments
        };
    }

    handleAdd = () => {
        if (!this._form.validate())
            return;

        const me = this;
        const rq = this.saveRequest();
        const url = this.urls().addComment;

        let comments = null;
        if (this.props.comments)
            comments = this.props.comments;

        new API().post(url, rq, {
            success: (r) => {
                if (comments) {
                    comments.unshift({
                        commentId: r.data.commentId,
                        reviewTypeDescription: r.data.reviewTypeDescription,
                        reviewTypeCode: r.data.reviewTypeCode,
                        queueTypeCode: r.data.queueTypeCode,
                        queueTypeDescription: r.data.queueTypeDescription,
                        commentTypeCode: r.data.commentTypeCode,
                        content: r.data.content,
                        addedDate: r.data.addedAt,
                        addedBy: r.data.addedBy
                    });
                }

                this.setState({
                    saving: false,
                    form: {
                        ...this.state.form,
                        ...r.data,
                        comments: comments,
                        original: {
                            ...this.state.form,
                            ...r.data
                        }
                    }
                }, () => {
                    if (me.props.onSave)
                        me.props.onSave(me.state.form);
                    me.close();
                });
            },
            error: r => {
                me.setState({ saving: false });
                Notifications.error(r.error.errorMessage);
                if (this.props.onError)
                    this.props.onError(r.error);
            }
        })
    }

    close = () => {
        this.setState(this.initialState(this.props), function () {
            this.props.onClose();
        });
    }

    handleChange = (form, callback) => {
        this.setState({ form }, callback);
    }

    renderCommentsSection() {
        return (
            <React.Fragment>
                <FormGroup>
                    {this.props.formLabel}
                    <TextAreaBox name="comments"
                        placeholder="Enter your comments here..."
                        required
                        maxLength={2500} />
                </FormGroup>
            </React.Fragment>
        )
    }

    render() {
        return (
            <Modal show={this.state.visible} onHide={this.close} backdrop="static">
                <Modal.Header>
                    {this.props.header}
                </Modal.Header>
                <Modal.Body>
                    <Form
                        onChange={this.handleChange}
                        values={this.state.form}
                        ref={(form) => { this._form = form }}>
                        <Row>
                            <Col sm={12}>
                                {this.renderCommentsSection()}
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="link" onClick={this.close} autoFocus>Cancel</Button>
                    <Button bsStyle="primary"
                        disabled={this.state.saving}
                        onClick={this.handleAdd}>
                        Add Comment & Save
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default CommentPopUp;

// Default properties
CommentPopUp.defaultProps = {
    commentTypeCode: 'NOR'
}


// WEBPACK FOOTER //
// ./src/areas/admin/certification/shared/CommentPopUp.js